export const regularRecipe = [
  {
    id: 1,
    title: "Biriyani Platter",
    price: 8.5,
    image:
      "https://www.tbsnews.net/sites/default/files/styles/big_3/public/images/2020/09/25/dhaka-kachchi-tbs.jpg",
    description:
      "A spiced mix of meat and rice, traditionally cooked over an open fire in a leather pot and served with borhani",
  },
  {
    id: 2,
    title: "Kabab Platter",
    price: 9.5,
    image:
      "https://www.tbsnews.net/sites/default/files/styles/infograph/public/images/2020/10/23/kabab_factory_.jpg",
    description:
      "A dish of Asian origin that typically combines small pieces of meat such as lamb or beef with vegetables grilled.",
  },
  {
    id: 3,
    title: "Mejban Platter",
    price: 8.0,
    image: "https://images.deliveryhero.io/image/fd-bd/LH/evbf-hero.jpg",
    description:
      "Succulent mutton. A tantalizing array of spices. Freshly roasted and ground. Cooked languorously over a lazy flame.",
  },
  {
    id: 4,
    title: "Dürüm Platter",
    price: 10.0,
    image:
      "https://www.shutterstock.com/image-photo/turkish-cuisine-very-tasty-satisfying-600nw-2103197252.jpg",
    description:
      "A dürüm is a Turkish wrap that is usually filled with typical döner kebab ingredients.",
  },
  {
    id: 5,
    title: "Döner Platter",
    price: 8.0,
    image: "https://image.stern.de/31721354/t/Fo/v3/w1440/r1/-/doener.jpg",
    description:
      "Doner kebabs are made from slices of marinated meat, which are placed on a large skewer and roasted while rotating.",
  },
  {
    id: 6,
    title: "Pizza Platter",
    price: 12.0,
    image:
      "https://www.zauberdergewuerze.de/magazin/wp-content/uploads/2023/03/05_oregano_istock-1174701047.jpg",
    description:
      "Pizza is a dish of Italian origin consisting of a usually round, flat base of leavened wheat-based dough topped with tomatoes, cheese, and often various other ingredients",
  },
];
